// extracted by mini-css-extract-plugin
export default {"containerCards":"Relatorio_containerCards__8tJXU"};